var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-relative"},[_c('img',{staticClass:"custom-icon",attrs:{"src":_vm.mail}})])}
var staticRenderFns = []

export { render, staticRenderFns }